<template>
  <vue-custom-scrollbar id="slide_wrap" class="slide-main effect-transition-fast" :settings="{maxScrollbarLength: 300}">
      <canvas id="slide_main"></canvas>
  </vue-custom-scrollbar>
</template>

<script>
import { fabric } from 'fabric'
import { mapState, mapActions } from 'vuex'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { STORE_KEY, KEY_TXT, KEY_SHAPE, KEY_PICTURE, KEY_VIDEO, KEY_AUDIO, KEY_SLIDE } from './../../_store/constants'
import { KEY_DEL_KEYBORAD } from '@/store/common/constants'
import mixinsDetailLesson from './../../_store/mixinsDetailLesson'

export default {
  name: 'CanvasSlide',
  mixins: [ mixinsDetailLesson ],
  props: {
    openListItemSlide: Boolean,
    openSidebarActions: Boolean,
  },
  components: {
    vueCustomScrollbar
  },
  data () {
    return {
      // slideObj: null,
      indexSlideActive: 0,
      isResizeDone: true,
      widthCanvas: 0,
      heightCanvas: 0,
      changeSlideShow: false
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['slidesMain', 'objActivitySlide', 'slideCurr', 'slideIndexVisible', 'scaleSlide'])
  },
  watch: {
    scaleSlide (newVal) {
      // if (newVal !== 1) {
      //   this.handleScaleSlide()
      // } else {
        this.slideCurr.clear()
        this.setSizieCanvas()
      // }
    },

    slideIndexVisible (newVal) {
      this.slideCurr.clear()
      setTimeout(() => {
        this.initPage()
      }, 500)
    },

    openSidebarActions () {
      this.slideCurr.clear()
      setTimeout(() => {
        this.setSizieCanvas()
      }, 300)
    },

    openListItemSlide () {
      this.slideCurr.clear()
      setTimeout(() => {
        this.setSizieCanvas()
      }, 300)
    }
  },
  mounted () {
    // window.addEventListener('resize', this.handleResize);
    this.acSetSlideCurr(new fabric.Canvas('slide_main'))
    this.initPage()
    window.addEventListener('keyup', this.onKeyup)
  },
  beforeDestroy () {
    window.removeEventListener('keyup', this.onKeyup)
    this.slideCurr.clear()
    this.acSetSlidesMain([])
    // window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions(STORE_KEY, ['acSetSlideCurr', 'acSetSlidesMain']),

    initPage () {
      this.setSizieCanvas()
      this.initFabric()
    },

    initFabric() {
      let self = this;
      fabric.Object.prototype.toObject = (function(toObject) {
        return function(propertiesToInclude) {
            propertiesToInclude = (propertiesToInclude || []).concat(['video_src']);
            propertiesToInclude = (propertiesToInclude || []).concat(['audio_src']);
            propertiesToInclude = (propertiesToInclude || []).concat(['file_name']);
            propertiesToInclude = (propertiesToInclude || []).concat(['layout']);
            propertiesToInclude = (propertiesToInclude || []).concat(['type_detail']);
            propertiesToInclude = (propertiesToInclude || []).concat(['position']);
            propertiesToInclude = (propertiesToInclude || []).concat(['file_uploaded']);
            propertiesToInclude = (propertiesToInclude || []).concat(['dimensions_percent']);
            return toObject.apply(this, [propertiesToInclude]);
        };
      })(fabric.Object.prototype.toObject),
      fabric.Object.prototype.set({
          transparentCorners: !1,
          borderColor: "rgba(77, 139, 255, 0.66)",
          cornerColor: "rgba(77, 139, 255, 0.66)",
          cornerStyle: "circle",
          cornerSize: 15,
          padding: 0
      });

      // this.slideCurr.on('object:moved', function(options) { self.eventElmCanvas(options, 'moved') })
      // this.slideCurr.on('object:rotated', function(options) { self.eventElmCanvas(options, 'rotated') })
      // this.slideCurr.on('object:scaled', function(options) { self.eventElmCanvas(options, 'scaled') })
      // this.slideCurr.on('object:created', function(options) { self.eventElmCanvas(options, 'created') });
      this.slideCurr.on('object:added', function(options) { self.eventElmCanvas(options, 'added') })
      this.slideCurr.on('object:modified', function(options) { self.eventElmCanvas(options, 'modified') })
      this.slideCurr.on('text:changed', function(options) { self.eventElmCanvas(options, 'text:changed') })
      // this.slideCurr.on('before:selection:cleared', function(options) { self.eventElmCanvas(options, 'before:selection:cleared') })
      // this.slideCurr.on('mouse:up', function(options) { self.eventElmCanvas(options, 'mouseUp') })
      // this.slideCurr.on("before:selection:cleared", function(t) {
      //     //console.log("before:selection:cleared");
      //     // that.savingSlider();
      // });
      this.slideCurr.renderAll()
    },

    setSizieCanvas () {
      // this.slideObj = this.slideCurr
      // this.slideObj.clear()
      let canvasEl = document.getElementById(`slide_main`)
      let wrapEl = document.getElementById('slide_wrap')
      if (canvasEl && wrapEl) {
        // let ctx = canvasEl.getContext('2d');
        // ctx.translate(0.5, 0.5);

        let widthVW = window.innerWidth > 1500 ? 80 : 70;

        // Set display size (vw/vh).
        let sizeWidth = widthVW * this.scaleSlide * wrapEl.clientWidth / 100;
        // let sizeHeight = 75 * wrapEl.clientHeight / 100 || 766;
        // Percent for size A4: 210x297: -> 1.414
        let sizeHeight = sizeWidth/2;

        // console.log('W/H:', sizeWidth, sizeHeight, wrapEl.clientWidth, wrapEl.clientHeight);

        // this.widthCanvas = sizeWidth
        // this.heightCanvas = sizeHeight
        this.slideCurr.setWidth(sizeWidth);
        this.slideCurr.setHeight(sizeHeight);
        this.setDataSaved({width: sizeWidth, height: sizeHeight})

        //Setting the canvasEl site and width to be responsive 
        // canvasEl.width = sizeWidth
        // canvasEl.height = sizeHeight
        // canvasEl.style.width = sizeWidth
        // canvasEl.style.height = sizeHeight
      }
    },

    onKeyup (val) {
      val.keyCode === KEY_DEL_KEYBORAD && this.removeObjectCurr()
      val.keyCode === 67 && this.copy()
      val.keyCode === 86 && this.paste()
    },

    removeObjectCurr () {
      let area = this.slideCurr.getActiveObject()
      // console.log('REMOVE: ', area);
      if (area) {
        this.slideCurr.remove(area)
        let indexItemDel = this.slidesMain[this.slideIndexVisible].items.findIndex(item => item.position === area.position)
        indexItemDel > -1 && this.slidesMain[this.slideIndexVisible].items.splice(indexItemDel, 1)
      }
    },

    async eventElmCanvas(val, nameEvt = '') {
      let self = this;
      // console.log('Hanlde change evt: ', val)
      let valTarget = await val.target;
      // await self.saveToImage()
      // await self.saveToSVG()
      if (valTarget) {
        let indexItemAc = self.slidesMain[self.slideIndexVisible].items.findIndex(item => item.position && item.position === valTarget.position)
        // console.log('evt elm: ', valTarget, indexItemAc, nameEvt)
        self.slidesMain[self.slideIndexVisible].items[indexItemAc] = valTarget
      }
      // self.saveToImage()
      // self.saveToSVG()
      let jsonValue = self.saveToJson()
      self.slidesMain[self.slideIndexVisible]['jsonValue'] = jsonValue
      self.acSetSlidesMain([...self.slidesMain])
      self.slideCurr.trigger('selection:cleared')
      // switch(nameEvt) {
      //   case 'added':
      //     console.log('Evt Add: ', valTarget);
      //     break;
      //   case 'scaled':
      //     console.log('Evt scaled: ', valTarget);
      //     break;
      //   default:
      //     console.log('Evt move: ', valTarget);
      //     break;
      // }
    },

    handleScaleSlide () {
      let canvasEl = document.getElementById(`slide_main`)
      if (canvasEl) {
        this.slideCurr.clear()
        const width = canvasEl.clientWidth*this.scaleSlide
        const height = canvasEl.clientHeight*this.scaleSlide
        // console.log('size: ', {width, height}, this.scaleSlide);
        this.slideCurr.setWidth(width)
        this.slideCurr.setHeight(height)
        this.setDataSaved({width, height})
      }
    },

    // handleResize () {
    //   console.log('Handle edit layout for resize evt')
    // }
  }
}
</script>

<style lang="scss" scoped>
#slide_wrap {
  height: calc(100vh - 115px);
  overflow: auto;

  .ps__rail-y {
    z-index: 9999;
  }
}
</style>